import { BehaviorSubject } from 'rxjs';

export default class PaymentRepository {
  planToDowngrade$ = new BehaviorSubject(null);
  studiesToRemove$ = new BehaviorSubject(null);
  constructor({ paymentService }) {
    this.paymentService = paymentService;
  }

  async createCaseCheckoutSession(studyId, currentRoute = null, type = 'Standard', caseId = null, patientId = null, successRoute = null) {
    return this.paymentService.createCaseCheckoutSession(studyId, currentRoute, type, caseId, patientId, successRoute);
  }

  async createPackageCheckoutSession(plan, currentRoute = null) {
    return this.paymentService.createPackageCheckoutSession(plan, currentRoute);
  }

  async createSubscriptionCheckoutSession(plan, currentRoute = null) {
    return this.paymentService.createSubscriptionCheckoutSession(plan, currentRoute);
  }

  async isValidSession(sessionId) {
    return this.paymentService.isValidSession(sessionId);
  }

  async redirectToCheckout(sessionId) {
    return this.paymentService.redirectToCheckout(sessionId);
  }

  cancelPlan() {
    return this.paymentService.cancelPlan();
  }
}
